import script from "./Doctor.vue?vue&type=script&setup=true&lang=js"
export * from "./Doctor.vue?vue&type=script&setup=true&lang=js"

import "./Doctor.vue?vue&type=style&index=0&id=952ad79e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-952ad79e"]])

export default __exports__